import { controls } from '../mininova';

const PATCH_CONTROL_CHANGED = 'PATCH_CONTROL_CHANGED';
const PATCH_CONTROL_LOCK_OFF = 'PATCH_CONTROL_LOCK_OFF';
const PATCH_CONTROL_LOCK_ON = 'PATCH_CONTROL_LOCK_ON';
const PATCH_DUMP_RECEIVED = 'PATCH_DUMP_RECEIVED';

export const patchControlChanged = (id, value) => (
  {
    type: PATCH_CONTROL_CHANGED,
    payload: {
      id,
      value,
    },
  }
);

export const patchControlLockOff = (id) => (
  {
    type: PATCH_CONTROL_LOCK_OFF,
    payload: {
      id,
    },
  }
);

export const patchControlLockOn = (id) => (
  {
    type: PATCH_CONTROL_LOCK_ON,
    payload: {
      id,
    },
  }
);

export const patchDumpReceived = data => (
  {
    type: PATCH_DUMP_RECEIVED,
    payload: {
      data,
    },
  }
);

const initialState = [];
for (let [id, control] of Object.entries(controls)) {
  initialState[id] = control.init;
}
initialState.locks = ['patch-name', 'tempo', 'osc-fixed-note'];

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PATCH_DUMP_RECEIVED:
      var name = '';
      for (var i=15;i<31;i++) {
          name += String.fromCharCode(action.payload.data[i]);
      }
      console.log("NAME: ",name);

      return {
        ...state,
        'patch-name':name,
        'osc-vibrato-depth': action.payload.data[42],
        'osc-vibrato-speed': action.payload.data[41],
        'osc-drift': action.payload.data[43],
        'osc-phase': action.payload.data[44],
        'osc-fixed-note': action.payload.data[45],
        'osc-1-wave': action.payload.data[46],
        'osc-1-semitones': action.payload.data[53],
        'osc-1-cents': action.payload.data[54],
        'osc-1-vsync': action.payload.data[49],
        'osc-1-pwwti': action.payload.data[48],
        'osc-1-hardness': action.payload.data[50],
        'osc-1-density': action.payload.data[51],
        'osc-1-densitydetune': action.payload.data[52],
        'osc-1-pitch': action.payload.data[55],
        'osc-1-wtint': action.payload.data[47],
        'osc-2-wave': action.payload.data[56],
        'osc-2-semitones': action.payload.data[63],
        'osc-2-cents': action.payload.data[64],
        'osc-2-vsync': action.payload.data[59],
        'osc-2-pwwti': action.payload.data[58],
        'osc-2-hardness': action.payload.data[60],
        'osc-2-density': action.payload.data[61],
        'osc-2-densitydetune': action.payload.data[62],
        'osc-2-pitch': action.payload.data[65],
        'osc-2-wtint': action.payload.data[57],
        'osc-3-wave': action.payload.data[66],
        'osc-3-semitones': action.payload.data[73],
        'osc-3-cents': action.payload.data[74],
        'osc-3-vsync': action.payload.data[69],
        'osc-3-pwwti': action.payload.data[68],
        'osc-3-hardness': action.payload.data[70],
        'osc-3-density': action.payload.data[71],
        'osc-3-densitydetune': action.payload.data[72],
        'osc-3-pitch': action.payload.data[75],
        'osc-3-wtint': action.payload.data[67],
        'osc-1-level': action.payload.data[76],
        'osc-2-level': action.payload.data[77],
        'osc-3-level': action.payload.data[78],
        'ring-mod-level-1-3': action.payload.data[79],
        'ring-mod-level-2-3': action.payload.data[80],
        'noise-level': action.payload.data[81],
        'noise-type': action.payload.data[82],
        'pre-fx-level': action.payload.data[83]-64,
        'post-fx-level': action.payload.data[84]-64,
        'filter-routing': action.payload.data[86],
        'filter-balance': action.payload.data[87]-64,
        'filter-freqlink':action.payload.data[88]&1,
        'filter-reslink': action.payload.data[88]&1-1,
        'filter-1-drive': action.payload.data[89],
        'filter-1-drive-type': action.payload.data[90],
        'filter-1-type': action.payload.data[91],
        'filter-1-track': action.payload.data[93],
        'filter-1-resonance': action.payload.data[94],
        'filter-1-frequency': action.payload.data[92],
        'filter-1-qnormalize': action.payload.data[95],
        'filter-1-env2-to-freq': action.payload.data[96],
        'filter-2-drive': action.payload.data[97],
        'filter-2-drive-type': action.payload.data[98],
        'filter-2-type': action.payload.data[99],
        'filter-2-track': action.payload.data[100],
        'filter-2-resonance': action.payload.data[103],
        'filter-2-frequency': action.payload.data[101],
        'filter-2-qnormalize': action.payload.data[104],
        'filter-2-env2-to-freq': action.payload.data[102],

        'env-1-attack': action.payload.data[116],
        'env-1-decay': action.payload.data[117],
        'env-1-sustain': action.payload.data[118],
        'env-1-release': action.payload.data[119],
        'env-1-trigger': action.payload.data[112]&1,
        'env-1-velocity': action.payload.data[115],
        'env-1-sustain-rate': action.payload.data[120],
        'env-1-sustain-time': action.payload.data[121],
        'env-1-ad-repeats': action.payload.data[122],
        'env-1-attack-track': action.payload.data[123],
        'env-1-decay-track': action.payload.data[124],
        'env-1-level-track': action.payload.data[125],
        'env-1-attack-slope': action.payload.data[126],
        'env-1-decay-slope': action.payload.data[127],
        'env-1-anim-trigger': action.payload.data[128],

        'env-2-attack': action.payload.data[130],
        'env-2-decay': action.payload.data[131],
        'env-2-sustain': action.payload.data[132],
        'env-2-release': action.payload.data[133],
        'env-2-trigger': (action.payload.data[112]&2) > 0 ? 1 : 0,
        'env-2-velocity': action.payload.data[129],
        'env-2-sustain-rate': action.payload.data[134],
        'env-2-sustain-time': action.payload.data[135],
        'env-2-ad-repeats': action.payload.data[136],
        'env-2-attack-track': action.payload.data[137],
        'env-2-decay-track': action.payload.data[138],
        'env-2-level-track': action.payload.data[139],
        'env-2-attack-slope': action.payload.data[140],
        'env-2-decay-slope': action.payload.data[141],
        'env-2-anim-trigger': action.payload.data[142],

        'env-3-delay': action.payload.data[143],
        'env-3-attack': action.payload.data[144],
        'env-3-decay': action.payload.data[145],
        'env-3-sustain': action.payload.data[146],
        'env-3-release': action.payload.data[147],
        'env-3-trigger': (action.payload.data[112]&4)>0?1:0,
        'env-3-sustain-rate': action.payload.data[148],
        'env-3-sustain-time': action.payload.data[149],
        'env-3-ad-repeats': action.payload.data[150],
        'env-3-attack-track': action.payload.data[151],
        'env-3-decay-track': action.payload.data[152],
        'env-3-level-track': action.payload.data[153],
        'env-3-attack-slope': action.payload.data[154],
        'env-3-decay-slope': action.payload.data[155],
        'env-3-anim-trigger': action.payload.data[156],

        'env-4-delay': action.payload.data[157],
        'env-4-attack': action.payload.data[158],
        'env-4-decay': action.payload.data[159],
        'env-4-sustain': action.payload.data[160],
        'env-4-release': action.payload.data[161],
        'env-4-trigger': (action.payload.data[112]&8)>0?1:0,
        'env-4-sustain-rate': action.payload.data[162],
        'env-4-sustain-time': action.payload.data[163],
        'env-4-ad-repeats': action.payload.data[164],
        'env-4-attack-track': action.payload.data[165],
        'env-4-decay-track': action.payload.data[166],
        'env-4-level-track': action.payload.data[167],
        'env-4-attack-slope': action.payload.data[168],
        'env-4-decay-slope': action.payload.data[169],
        'env-4-anim-trigger': action.payload.data[170],

        'env-5-delay': action.payload.data[171],
        'env-5-attack': action.payload.data[172],
        'env-5-decay': action.payload.data[173],
        'env-5-sustain': action.payload.data[174],
        'env-5-release': action.payload.data[175],
        'env-5-trigger': (action.payload.data[112]&16)> 0 ? 1 : 0,
        'env-5-sustain-rate': action.payload.data[176],
        'env-5-sustain-time': action.payload.data[177],
        'env-5-ad-repeats': action.payload.data[178],
        'env-5-attack-track': action.payload.data[179],
        'env-5-decay-track': action.payload.data[180],
        'env-5-level-track': action.payload.data[181],
        'env-5-attack-slope': action.payload.data[182],
        'env-5-decay-slope': action.payload.data[183],
        'env-5-anim-trigger': action.payload.data[184],

        'env-6-delay': action.payload.data[185],
        'env-6-attack': action.payload.data[186],
        'env-6-decay': action.payload.data[187],
        'env-6-sustain': action.payload.data[188],
        'env-6-release': action.payload.data[189],
        'env-6-trigger': (action.payload.data[112]&32) > 0 ? 1 : 0,
        'env-6-sustain-rate': action.payload.data[190],
        'env-6-sustain-time': action.payload.data[191],
        'env-6-ad-repeats': action.payload.data[192],
        'env-6-attack-track': action.payload.data[193],
        'env-6-decay-track': action.payload.data[194],
        'env-6-level-track': action.payload.data[195],
        'env-6-attack-slope': action.payload.data[196],
        'env-6-decay-slope': action.payload.data[197],
        'env-6-anim-trigger': action.payload.data[198],

        'lfo-1-waveform': action.payload.data[199],
        'lfo-1-phase-offset': action.payload.data[200],
        'lfo-1-slew-rate': action.payload.data[201],
        'lfo-1-delay': action.payload.data[203],
        'lfo-1-delay-sync': action.payload.data[204],
        'lfo-1-rate': action.payload.data[205],
        'lfo-1-rate-sync': action.payload.data[206],
        'lfo-1-one-shot': (action.payload.data[207]&1) > 0 ? 1 : 0,
        'lfo-1-key-sync': (action.payload.data[207]&2) > 0 ? 1 : 0,
        'lfo-1-common-sync': (action.payload.data[207]&4) > 0 ? 1 : 0,
        'lfo-1-delay-trigger': (action.payload.data[207]&8) > 0 ? 1 : 0,
        'lfo-1-fade-mode': (action.payload.data[207]>>4),

        'lfo-2-waveform': action.payload.data[208],
        'lfo-2-phase-offset': action.payload.data[209],
        'lfo-2-slew-rate': action.payload.data[210],
        'lfo-2-delay': action.payload.data[212],
        'lfo-2-delay-sync': action.payload.data[213],
        'lfo-2-rate': action.payload.data[214],
        'lfo-2-rate-sync': action.payload.data[215],
        'lfo-2-one-shot': (action.payload.data[216]&1)> 0 ? 1 : 0,
        'lfo-2-key-sync': (action.payload.data[216]&2) > 0 ? 1 : 0,
        'lfo-2-common-sync': (action.payload.data[216]&4) > 0 ? 1 : 0,
        'lfo-2-delay-trigger': (action.payload.data[216]&8) > 0 ? 1 : 0,
        'lfo-2-fade-mode': action.payload.data[216]>>4,

        'lfo-3-waveform': action.payload.data[217],
        'lfo-3-phase-offset': action.payload.data[218],
        'lfo-3-slew-rate': action.payload.data[219],
        'lfo-3-delay': action.payload.data[221],
        'lfo-3-delay-sync': action.payload.data[222],
        'lfo-3-rate': action.payload.data[223],
        'lfo-3-rate-sync': action.payload.data[224],
        'lfo-3-one-shot': (action.payload.data[225]&1) > 0 ? 1 : 0,
        'lfo-3-key-sync': (action.payload.data[225]&2) > 0 ? 1 : 0,
        'lfo-3-common-sync': (action.payload.data[225]&4) > 0 ? 1 : 0,
        'lfo-3-delay-trigger': (action.payload.data[225]&8) > 0 ? 1 : 0,
        'lfo-3-fade-mode': action.payload.data[225]>4,

        'fx-pan-position': action.payload.data[105]-64,
        'fx-pan-rate': action.payload.data[106],
        'fx-pan-sync': action.payload.data[107],
        'fx-pan-mod-depth': action.payload.data[108],
        'fx-routing': action.payload.data[226],
        'fx-feedback': action.payload.data[227],
        'fx-1-level': action.payload.data[233],
        'fx-2-level': action.payload.data[234],
        'fx-3-level': action.payload.data[235],
        'fx-4-level': action.payload.data[236],
        'fx-5-level': action.payload.data[237],
        'fx-1-select': action.payload.data[228],
        'fx-2-select': action.payload.data[229],
        'fx-3-select': action.payload.data[230],
        'fx-4-select': action.payload.data[231],
        'fx-5-select': action.payload.data[232],

        'eq-bass-frequency': action.payload.data[238],
        'eq-bass-level': action.payload.data[239]-64,
        'eq-mid-frequency': action.payload.data[240],
        'eq-mid-level': action.payload.data[241]-64,
        'eq-treble-frequency': action.payload.data[242],
        'eq-treble-level': action.payload.data[243]-64,

        'compres-1-ratio': action.payload.data[244],
        'compres-1-treshold': action.payload.data[245]-60,
        'compres-1-attack': action.payload.data[246],
        'compres-1-release': action.payload.data[247],
        'compres-1-hold': action.payload.data[248],
        'compres-1-gain': action.payload.data[249],

        'compres-2-ratio': action.payload.data[250],
        'compres-2-treshold': action.payload.data[251]-60,
        'compres-2-attack': action.payload.data[252],
        'compres-2-release': action.payload.data[253],
        'compres-2-hold': action.payload.data[254],
        'compres-2-gain': action.payload.data[255],

        'distort-1-type': action.payload.data[256],
        'distort-1-compensation': action.payload.data[257],
        'distort-1-level': action.payload.data[258]-60,
        'distort-2-type': action.payload.data[259],
        'distort-2-compensation': action.payload.data[260],
        'distort-2-level': action.payload.data[261]-60,

        'delay-1-time': action.payload.data[262],
        'delay-1-sync': action.payload.data[263],
        'delay-1-feedback': action.payload.data[264],
        'delay-1-width': action.payload.data[265],
        'delay-1-lr-ratio': action.payload.data[266],
        'delay-1-slew-rate': action.payload.data[267],

        'delay-2-time': action.payload.data[268],
        'delay-2-sync': action.payload.data[269],
        'delay-2-feedback': action.payload.data[270],
        'delay-2-width': action.payload.data[271],
        'delay-2-lr-ratio': action.payload.data[272],
        'delay-2-slew-rate': action.payload.data[273],

        'reverb-1-type': action.payload.data[274],
        'reverb-1-decay': action.payload.data[275],
        'reverb-1-damping': action.payload.data[276],
        'reverb-2-type': action.payload.data[277],
        'reverb-2-decay': action.payload.data[278],
        'reverb-2-damping': action.payload.data[279],

        'chorus-1-type': action.payload.data[280],
        'chorus-1-rate': action.payload.data[281],
        'chorus-1-rate-sync': action.payload.data[282],
        'chorus-1-feedback': action.payload.data[283]-64,
        'chrous-1-mod-depth': action.payload.data[284],
        'chorus-1-delay': action.payload.data[285],
        'chorus-2-type': action.payload.data[286],
        'chorus-2-rate': action.payload.data[287],
        'chorus-2-rate-sync': action.payload.data[288],
        'chorus-2-feedback': action.payload.data[289]-64,
        'chrous-2-mod-depth': action.payload.data[290],
        'chorus-2-delay': action.payload.data[291],
        'chorus-3-type': action.payload.data[292],
        'chorus-3-rate': action.payload.data[293],
        'chorus-3-rate-sync': action.payload.data[294],
        'chorus-3-feedback': action.payload.data[295]-64,
        'chrous-3-mod-depth': action.payload.data[296],
        'chorus-3-delay': action.payload.data[297],
        'chorus-4-type': action.payload.data[298],
        'chorus-4-rate': action.payload.data[299],
        'chorus-4-rate-sync': action.payload.data[300],
        'chorus-4-feedback': action.payload.data[301]-64,
        'chrous-4-mod-depth': action.payload.data[302],
        'chorus-4-delay': action.payload.data[303],

        'gator-on': action.payload.data[304]&1,
        'gator-key-sync': (action.payload.data[304]&2)>0?1:0,
        'gator-key-latch': (action.payload.data[304]&4)>0?1:0,
        'gator-rate-sync': action.payload.data[305],
        'gator-mode': action.payload.data[306],
        'gator-edge-slew': action.payload.data[308],
        'gator-hold': action.payload.data[309],
        'gator-lr-delay': action.payload.data[310]-64,
        'gator-level-1': action.payload.data[451]&7,
        'gator-level-2': (action.payload.data[451]>>3)&7, 
        'gator-level-3': action.payload.data[452]&7,
        'gator-level-4': (action.payload.data[452]>>3)&7,
        'gator-level-5': action.payload.data[453]&7,
        'gator-level-6': (action.payload.data[453]>>3)&7,
        'gator-level-7': action.payload.data[454]&7,
        'gator-level-8': (action.payload.data[454]>>3)&7,
        'gator-level-9': action.payload.data[455]&7,
        'gator-level-10': (action.payload.data[455]>>3)&7,
        'gator-level-11': action.payload.data[456]&7,
        'gator-level-12': (action.payload.data[456]>>3)&7,
        'gator-level-13': action.payload.data[457]&7,
        'gator-level-14': (action.payload.data[457]>>3)&7,
        'gator-level-15': action.payload.data[458]&7,
        'gator-level-16': (action.payload.data[458]>>3)&7,
        'gator-level-17': action.payload.data[459]&7,
        'gator-level-18': (action.payload.data[459]>>3)&7,
        'gator-level-19': action.payload.data[460]&7,
        'gator-level-20': (action.payload.data[460]>>3)&7,
        'gator-level-21': action.payload.data[461]&7,
        'gator-level-22': (action.payload.data[461]>>3)&7,
        'gator-level-23': action.payload.data[462]&7,
        'gator-level-24': (action.payload.data[462]>>3)&7,
        'gator-level-25': action.payload.data[463]&7,
        'gator-level-26': (action.payload.data[463]>>3)&7,
        'gator-level-27': action.payload.data[464]&7,
        'gator-level-28': (action.payload.data[464]>>3)&7,
        'gator-level-29': action.payload.data[465]&7,
        'gator-level-30': (action.payload.data[465]>>3)&7,
        'gator-level-31': action.payload.data[466]&7,
        'gator-level-32': (action.payload.data[466]>>3)&7,

        'arp-on': action.payload.data[317]&1,
        'arp-key-latch': (action.payload.data[317]&4) > 0 ? 1 : 0,
        'arp-octaves': action.payload.data[318]+1,
        'arp-rate-sync': action.payload.data[319],
        'arp-gate': action.payload.data[320],
        'arp-mode': action.payload.data[321],
        'arp-pattern': action.payload.data[322],
        'arp-swing': action.payload.data[324],
        'arp-length': (action.payload.data[325]>>1)+1,
        'arp-step-1': (action.payload.data[325]&32) > 0 ? 1 : 0,
        'arp-step-2': (action.payload.data[326]&1 ) > 0 ? 1 : 0,
        'arp-step-3': (action.payload.data[326]&2 ) > 0 ? 1 : 0,
        'arp-step-4': (action.payload.data[326]&4 ) > 0 ? 1 : 0,
        'arp-step-5': (action.payload.data[326]&8 ) > 0 ? 1 : 0,
        'arp-step-6': (action.payload.data[326]&16) > 0 ? 1 : 0,
        'arp-step-7': (action.payload.data[326]&32)  > 0 ? 1 : 0,
        'arp-step-8': (action.payload.data[326]&64)  > 0 ? 1 : 0,

        'vocoder-level': action.payload.data[327],
        'vocoder-carier-level': action.payload.data[328],
        'vocoder-modulator-level': action.payload.data[329],
        'vocoder-resonance': action.payload.data[330],
        'vocoder-decay': action.payload.data[331],
        'vocoder-gate-threshold': action.payload.data[332],
        'vocoder-gate-release': action.payload.data[333],
        'vocoder-spectrum-level-1': action.payload.data[467],
        'vocoder-spectrum-level-2': action.payload.data[468],
        'vocoder-spectrum-level-3': action.payload.data[469],
        'vocoder-spectrum-level-4': action.payload.data[470],
        'vocoder-spectrum-level-5': action.payload.data[471],
        'vocoder-spectrum-level-6': action.payload.data[472],
        'vocoder-spectrum-level-7': action.payload.data[473],
        'vocoder-spectrum-level-8': action.payload.data[474],
        'vocoder-spectrum-level-9': action.payload.data[475],
        'vocoder-spectrum-level-10': action.payload.data[476],
        'vocoder-spectrum-level-11': action.payload.data[477],
        'vocoder-spectrum-level-12': action.payload.data[478],
        'vocoder-spectrum-level-13': action.payload.data[479],
        'vocoder-spectrum-level-14': action.payload.data[480],
        'vocoder-spectrum-level-15': action.payload.data[481],
        'vocoder-spectrum-level-16': action.payload.data[482],
        'vocoder-spectrum-level-17': action.payload.data[483],
        'vocoder-spectrum-level-18': action.payload.data[484],
        'vocoder-spectrum-level-19': action.payload.data[485],
        'vocoder-spectrum-level-20': action.payload.data[486],
        'vocoder-spectrum-level-21': action.payload.data[487],
        'vocoder-spectrum-level-22': action.payload.data[488],
        'vocoder-spectrum-level-23': action.payload.data[489],
        'vocoder-spectrum-level-24': action.payload.data[490],
        'vocoder-spectrum-level-25': action.payload.data[491],
        'vocoder-spectrum-level-26': action.payload.data[492],
        'vocoder-spectrum-level-27': action.payload.data[493],
        'vocoder-spectrum-level-28': action.payload.data[494],
        'vocoder-spectrum-level-29': action.payload.data[495],
        'vocoder-spectrum-level-30': action.payload.data[496],
        'vocoder-spectrum-level-31': action.payload.data[497],
        'vocoder-spectrum-level-32': action.payload.data[498],
        //'vocoder-spectrum-resample': action.payload.data[0],
        'chorder-transpose': action.payload.data[335],
        'chorder-on': action.payload.data[334]&1,
        'chorder-count': action.payload.data[499],
        'chorder-key-2': action.payload.data[500],
        'chorder-key-3': action.payload.data[501],
        'chorder-key-4': action.payload.data[502],
        'chorder-key-5': action.payload.data[503],
        'chorder-key-6': action.payload.data[504],
        'chorder-key-7': action.payload.data[505],
        'chorder-key-8': action.payload.data[506],
        'chorder-key-9': action.payload.data[507],
        'chorder-key-10': action.payload.data[508],

        'vocal-tune-shift': action.payload.data[336]-64,
        'vocal-tune-bend': action.payload.data[337]-64,
        'vocal-tune-mode': action.payload.data[439]&3,
        'vocal-tune-insert': action.payload.data[439]>>5,
        'vocal-tune-scale-type': action.payload.data[440],
        'vocal-tune-scale-key': action.payload.data[441],
        'vocal-tune-correction-time': action.payload.data[442],
        'vocal-tune-level': action.payload.data[443],
        'vocal-tune-vibrato': action.payload.data[444],
        'vocal-tune-vibrato-mod-wheel': action.payload.data[445],
        'vocal-tune-vibrato-rate': action.payload.data[446],

        'mod-1-src-1': action.payload.data[339],
        'mod-1-src-2': action.payload.data[340],
        'mod-1-anim': action.payload.data[341],
        'mod-1-depth': action.payload.data[342]-64,
        'mod-1-dest': action.payload.data[343],

        'mod-2-src-1': action.payload.data[344],
        'mod-2-src-2': action.payload.data[345],
        'mod-2-anim': action.payload.data[346],
        'mod-2-depth': action.payload.data[347]-64,
        'mod-2-dest': action.payload.data[348],

        'mod-3-src-1': action.payload.data[349],
        'mod-3-src-2': action.payload.data[350],
        'mod-3-anim': action.payload.data[351],
        'mod-3-depth': action.payload.data[352]-64,
        'mod-3-dest': action.payload.data[353],
        'mod-4-src-1': action.payload.data[354],
        'mod-4-src-2': action.payload.data[355],
        'mod-4-anim': action.payload.data[356],
        'mod-4-depth': action.payload.data[357]-64,
        'mod-4-dest': action.payload.data[358],
        'mod-5-src-1': action.payload.data[359],
        'mod-5-src-2': action.payload.data[360],
        'mod-5-anim': action.payload.data[361],
        'mod-5-depth': action.payload.data[362]-64,
        'mod-5-dest': action.payload.data[363],
        'mod-6-src-1': action.payload.data[364],
        'mod-6-src-2': action.payload.data[365],
        'mod-6-anim': action.payload.data[366],
        'mod-6-depth': action.payload.data[367]-64,
        'mod-6-dest': action.payload.data[368],
        'mod-7-src-1': action.payload.data[369],
        'mod-7-src-2': action.payload.data[370],
        'mod-7-anim': action.payload.data[371],
        'mod-7-depth': action.payload.data[372]-64,
        'mod-7-dest': action.payload.data[373],
        'mod-8-src-1': action.payload.data[374],
        'mod-8-src-2': action.payload.data[375],
        'mod-8-anim': action.payload.data[376],
        'mod-8-depth': action.payload.data[377]-64,
        'mod-8-dest': action.payload.data[378],
        'mod-9-src-1': action.payload.data[379],
        'mod-9-src-2': action.payload.data[380],
        'mod-9-anim': action.payload.data[381],
        'mod-9-depth': action.payload.data[382]-64,
        'mod-9-dest': action.payload.data[383],
        'mod-10-src-1': action.payload.data[384],
        'mod-10-src-2': action.payload.data[385],
        'mod-10-anim': action.payload.data[386],
        'mod-10-depth': action.payload.data[387]-64,
        'mod-10-dest': action.payload.data[388],
        'mod-11-src-1': action.payload.data[389],
        'mod-11-src-2': action.payload.data[390],
        'mod-11-anim': action.payload.data[391],
        'mod-11-depth': action.payload.data[392]-64,
        'mod-11-dest': action.payload.data[393],
        'mod-12-src-1': action.payload.data[394],
        'mod-12-src-2': action.payload.data[395],
        'mod-12-anim': action.payload.data[396],
        'mod-12-depth': action.payload.data[397]-64,
        'mod-12-dest': action.payload.data[398],
        'mod-13-src-1': action.payload.data[399],
        'mod-13-src-2': action.payload.data[400],
        'mod-13-anim': action.payload.data[401],
        'mod-13-depth': action.payload.data[402]-64,
        'mod-13-dest': action.payload.data[403],
        'mod-14-src-1': action.payload.data[404],
        'mod-14-src-2': action.payload.data[405],
        'mod-14-anim': action.payload.data[406],
        'mod-14-depth': action.payload.data[407]-64,
        'mod-14-dest': action.payload.data[408],
        'mod-15-src-1': action.payload.data[409],
        'mod-15-src-2': action.payload.data[410],
        'mod-15-anim': action.payload.data[411],
        'mod-15-depth': action.payload.data[412]-64,
        'mod-15-dest': action.payload.data[413],
        'mod-16-src-1': action.payload.data[414],
        'mod-16-src-2': action.payload.data[415],
        'mod-16-anim': action.payload.data[416],
        'mod-16-depth': action.payload.data[417]-64,
        'mod-16-dest': action.payload.data[418],
        'mod-17-src-1': action.payload.data[419],
        'mod-17-src-2': action.payload.data[420],
        'mod-17-anim': action.payload.data[421],
        'mod-17-depth': action.payload.data[422]-64,
        'mod-17-dest': action.payload.data[423],
        'mod-18-src-1': action.payload.data[424],
        'mod-18-src-2': action.payload.data[425],
        'mod-18-anim': action.payload.data[426],
        'mod-18-depth': action.payload.data[427]-64,
        'mod-18-dest': action.payload.data[428],
        'mod-19-src-1': action.payload.data[429],
        'mod-19-src-2': action.payload.data[430],
        'mod-19-anim': action.payload.data[431],
        'mod-19-depth': action.payload.data[432]-64,
        'mod-19-dest': action.payload.data[433],
          
        'mod-20-src-1': action.payload.data[434],
        'mod-20-src-2': action.payload.data[435],
        'mod-20-anim': action.payload.data[436],
        'mod-20-depth': action.payload.data[437]-64,
        'mod-20-dest': action.payload.data[438],

        'tweak-1': action.payload.data[510],
        'tweak-2': action.payload.data[512],
        'tweak-3': action.payload.data[514],
        'tweak-4': action.payload.data[516],
        'tweak-5': action.payload.data[518],
        'tweak-6': action.payload.data[520],
        'tweak-7': action.payload.data[522],
        'tweak-8': action.payload.data[524],

      };
    case PATCH_CONTROL_CHANGED:
      return {
        ...state,
        [action.payload.id]: action.payload.value,
      };
    case PATCH_CONTROL_LOCK_OFF:
      return {
        ...state,
        locks: state.locks.filter(id => id !== action.payload.id),
      };
    case PATCH_CONTROL_LOCK_ON:
      return {
        ...state,
        locks: [...state.locks, action.payload.id],
      };
    default:
      return state;
  }
};
